/**
 * Consulting B2B - Contracts Page
 * Manage recurring consulting contracts
 */

import { useEffect } from 'react';
import { AllContractsPage } from '@/components/industry/pages/AllContractsPage';
import { CompanyType } from '@/types/company';
import { MainLayout } from "@/components/MainLayout";

export default function ConsultingContractsPage() {
  useEffect(() => {
    document.title = 'Contratos | Controle Financeiro';
  }, []);

  return (
<MainLayout>
    <AllContractsPage
      domain={CompanyType.CONSULTING_B2B}
      pageTitle="Contratos de Consultoria"
      pageDescription="Gerencie contratos recorrentes de consultoria e assessoria"
    />
  
    </MainLayout>);
}

